export default {"src":"/_next/static/media/mail.c33c7ab9.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};